import { selectCanRedo, selectCanUndo, selectLiveConfigurationVersion } from "../selectors/editingHistorySelectors.ts";
import { createTypedAsyncThunk } from "../utils/createTypedAsyncThunk.ts";
import { createCurrentReportAction, createEditingHistoryAction, createMetaDataAction } from "../utils/storeUtils.ts";
import { fieldsStateActions } from "./fieldStatesThunks.ts";
import { changeDataSet } from "./metaDataThunks.ts";

export const baselineEditingHistory = createTypedAsyncThunk(
  "store/baselineEditingHistory",
  (_, { dispatch, getState }) => {
    const version = selectLiveConfigurationVersion(getState());
    if (version) {
      dispatch(createEditingHistoryAction("baselined", version));
    }
  }
);

const moveInEditingHistory = createTypedAsyncThunk<void, number>(
  "store/moveInEditingHistory",
  (step, { dispatch, getState }) => {
    const state = getState();
    const canMove = step < 0 ? selectCanUndo(state) : selectCanRedo(state);
    const index = state.editingHistory.index + step;
    const version = state.editingHistory.versions[index];
    if (!canMove || !version) {
      return;
    }

    dispatch(createEditingHistoryAction("moved", index));
    if (version.dataSetId && version.dataSetId !== state.metaData.dataSetId) {
      dispatch(changeDataSet(version.dataSetId));
    }
    dispatch(createCurrentReportAction("updateCurrentReportType", version.reportType));
    dispatch(createMetaDataAction("updateReportType", version.reportType));
    dispatch(fieldsStateActions.resetFieldsState(version.reportType));
    dispatch(
      fieldsStateActions.initializeFieldsState({ configuration: version.configuration, reportType: version.reportType })
    );
    dispatch(baselineEditingHistory());
  }
);

export const undoEditing = (): ReturnType<typeof moveInEditingHistory> => moveInEditingHistory(-1);

export const redoEditing = (): ReturnType<typeof moveInEditingHistory> => moveInEditingHistory(1);
